module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function() {
        return [_vm._v("\n      No Data\n    ")]
      },
      proxy: true
    }, {
      key: "default",
      fn: function() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v("Requestor")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Date Time")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Old Amount")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("New Amount")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Reasons")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.pairing.activity), function(item, index) {
          return _c('tr', {
            key: index
          }, [_c('td', [_vm._v(_vm._s(item.requestor || '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.utils.func.formatCustomDate(item.createdAt, 'DD/MM/YYYY hh:mm:ss')))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.oldAmount)))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.newAmount)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.reasons))]), _vm._v(" "), _c('td', {
            staticStyle: {
              "width": "100px"
            }
          }, [(item.status === 'pending') ? _c('div', {
            staticClass: "text-center"
          }, [_c('v-btn', {
            staticClass: "btn__p100 ma-1",
            attrs: {
              "small": "",
              "color": "success"
            },
            on: {
              "click": function($event) {
                return _vm.updatePairingActivity(item, 'approve')
              }
            }
          }, [_vm._v("\n                Approve\n              ")]), _vm._v(" "), _c('v-btn', {
            staticClass: "btn__p100 ma-1",
            attrs: {
              "small": "",
              "color": "error"
            },
            on: {
              "click": function($event) {
                return _vm.updatePairingActivity(item, 'reject')
              }
            }
          }, [_vm._v("\n                Reject\n              ")])], 1) : _c('div', [(item.status === 'approve') ? _c('v-chip', {
            attrs: {
              "color": "success",
              "x-small": "",
              "text-color": "white"
            }
          }, [_vm._v("\n                Approved\n              ")]) : _vm._e(), _vm._v(" "), (item.status === 'reject') ? _c('v-chip', {
            attrs: {
              "color": "red",
              "x-small": "",
              "text-color": "white"
            }
          }, [_vm._v("\n                Rejected\n              ")]) : _vm._e(), _vm._v(" "), (item.status === 'cancel') ? _c('v-chip', {
            attrs: {
              "color": "red",
              "x-small": "",
              "text-color": "white"
            }
          }, [_vm._v("\n                Cancelled\n              ")]) : _vm._e(), _vm._v(" "), (item.actor) ? _c('span', {
            staticClass: "text-caption",
            staticStyle: {
              "font-size": "10px!important"
            }
          }, [_vm._v("by " + _vm._s(item.actor))]) : _vm._e()], 1)])])
        }), 0)]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "subtitle-1 font-weight-bold"
  }, [_vm._v("Payout History")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-577e2f69"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/PairingInfluencer/PayoutActivityDataTable.vue
// module id = 2135
// module chunks = 0